global.initializeAppTitle()
global.initializeAppColorCustomization()